/**
 * 會議示範的 11 句。**內容是虛構的**（週會-0915.m4a，王姿涵／陳彥廷），只是示意，
 * 不接真實音檔、也不會真的播放；跟字幕示範一樣不進 i18n——它是「一份逐字稿長這樣」
 * 的展示品，不是可翻譯的文案。
 *
 * 逐字從設計稿 `site-transcription.html` 的 `.te-cue` 抄過來。
 */

export interface MeetingCue {
  start: number
  end: number
  speaker: 1 | 2
  text: string
}

export const MEETING_SPEAKERS: Record<1 | 2, string> = {
  1: '王姿涵',
  2: '陳彥廷',
}

export const FILE_NAME = '週會-0915.m4a'
export const TOTAL_LABEL = '27:18'

/**
 * 波形與段落塊畫的是**放大檢視的前 75 秒**，不是整段 27 分鐘：一屏畫 27 分鐘
 * 等於每句只剩不到一個 pixel。時間軸上的所有百分比都以它為分母。
 */
export const WINDOW_SECS = 75

/** 播放到最後一句結束就停。 */
export const PLAYBACK_END_SECS = 71.6

/** 進站時停在第一句上。 */
export const INITIAL_POSITION_SECS = 4.12

export const MEETING_CUES: MeetingCue[] = [
  { start: 4.12, end: 8.46, speaker: 1, text: '那我們先確認 staging 這版的 latency 有沒有壓下來，再決定要不要延後上線。' },
  { start: 8.46, end: 14.9, speaker: 2, text: '目前 p95 大概掉了三成，不過那是在關掉 batch worker 的情況下量的。' },
  { start: 15.02, end: 19.3, speaker: 1, text: '那開著的時候呢？我們上線那天 worker 不可能關。' },
  { start: 19.3, end: 26.78, speaker: 2, text: '開著大概只掉一成五，所以我建議延一週，先把 worker 那邊的 CI 修好再量一次。' },
  { start: 27.1, end: 32.84, speaker: 1, text: '延一週的話是 9/22，行銷那邊的排期我來喬。' },
  { start: 33.2, end: 40.62, speaker: 2, text: '好，CI 我這週三前修好，修好就重量一次 p95。' },
  { start: 41.05, end: 46.7, speaker: 1, text: '那驗收就以 worker 開著的數字為準，不要再拿關掉的量。' },
  { start: 47.0, end: 51.88, speaker: 2, text: '同意。量完我直接貼在頻道裡。' },
  { start: 52.3, end: 57.95, speaker: 1, text: '還有一件事，首頁拆三頁那個，我們還要等 A/B 結果嗎？' },
  { start: 58.2, end: 63.74, speaker: 2, text: '我覺得不用等了，設計稿都定了，直接照設計稿走。' },
  { start: 64.1, end: 71.6, speaker: 1, text: 'OK，那就不等了。我等一下把新的上線日期通知客服。' },
]
